export default __webpack_public_path__ + "static/media/frame-6.71800125.png";